// extracted by mini-css-extract-plugin
export default {"calendarElement":"styles_calendarElement__l+xEZ"};